module.exports = __webpack_public_path__ + "img/projectbanner3.34c095a7.jpg";